function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */

import React from "react";
import { SidePanel, SidePanelContainer } from "@console/cloud-pal-community/components/Basic";
import About from './about.jsx';
import autoBind from 'react-autobind';
import msgs from '../../nls/setup/deploy/deploy.properties';
var WizardToolsPanel = /*#__PURE__*/function (_React$Component) {
  function WizardToolsPanel(props) {
    var _this;
    _classCallCheck(this, WizardToolsPanel);
    _this = _callSuper(this, WizardToolsPanel, [props]);
    autoBind(_this);
    return _this;
  }
  _inherits(WizardToolsPanel, _React$Component);
  return _createClass(WizardToolsPanel, [{
    key: "render",
    value: function render() {
      if (!this.props.show) {
        return null;
      }
      var _this$props = this.props,
        availableCapabilities = _this$props.availableCapabilities,
        baseName = _this$props.baseName,
        locale = _this$props.locale,
        phase = _this$props.phase,
        templateMetadata = _this$props.templateMetadata,
        wizard = _this$props.wizard;
      var mode = "side-panel";
      var showTools = true;
      if (wizard && wizard.isV2()) {
        mode = "step";
        showTools = false;
      }
      var aboutContent = /*#__PURE__*/React.createElement(About, _extends({
        availableCapabilities: availableCapabilities,
        baseName: baseName,
        displayMode: mode,
        locale: locale,
        phase: phase,
        onClickGetStarted: this.props.handleCancel,
        showTools: showTools,
        templateMetadata: templateMetadata
      }, wizard ? {
        wizard: wizard
      } : {}));
      if (wizard && wizard.isV2()) {
        return aboutContent;
      }
      return /*#__PURE__*/React.createElement(SidePanelContainer, {
        hasOverlay: true,
        hideBottomNav: true,
        isOpen: true,
        onCancelClick: this.props.handleCancel,
        onCloseClick: this.props.handleCancel,
        onDoneClick: this.props.handleCancel,
        panelSize: "xl"
      }, /*#__PURE__*/React.createElement(SidePanel, {
        className: "wizard-side-panel",
        id: "run-pipeline-side-panel",
        title: msgs.get("label.detailsButton", locale)
      }, aboutContent));
    }
  }]);
}(React.Component);
export { WizardToolsPanel as default };